module.exports = __webpack_public_path__ + "45bea5a582ab1c44cab6ecab10101ddf.png";